import { render, staticRenderFns } from "./historical-query.vue?vue&type=template&id=0be039a2"
import script from "./historical-query.vue?vue&type=script&lang=ts"
export * from "./historical-query.vue?vue&type=script&lang=ts"
import style0 from "./historical-query.vue?vue&type=style&index=0&id=0be039a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports